/**
 * Mutations for wordpress/posts module
 */
import types from './types'
import {isUpdatedComponent} from '@/helpers'

const mutations = {
  [types.FETCH]: (state, payload) => {
    state.posts = payload
  },
  [types.CREATE]: (state, payload) => {
    if (!state.posts.some(id => id === payload.id)) {
      state.posts.unshift(payload)
    }
  },
  [types.UPDATE]: (state, payload) => {
    state.posts[state.posts.findIndex(post => post.id === payload.id)] = payload
  },
  [types.DELETE]: (state, payload) => {
    state.posts.splice(state.posts.findIndex(post => post.id === payload.id), 1)
  },
  [types.SELECT]: (state, payload) => {
    state.selected = state.posts[state.posts.findIndex(post => post.id === +payload)]
    // state.selected.components内のコンポーネントで最新でないものをフィルターする
    if (state.selected.components) state.selected.components = state.selected.components.filter(component => isUpdatedComponent(component))
  },
  [types.DESELECT]: (state, payload) => {
    state.selected = null
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/posts/mutations.js